import { Injectable, inject, signal } from '@angular/core';
import type { Observable } from 'rxjs';

import { LEARNING_HUB_PATH } from '@app/shared/constants/api-route.config';
import type { ListResponse } from '@app/shared/services/mixins/crud.service';
import { RestService } from '@app/shared/services/rest.service';

export interface LearningTourAdapter {
    id: number;
    title: string;
    description: string;
    sortOrder: number;
    key: string;
    group: string;
    tag: string;
    userState: 'skipped' | 'finished';
}

export interface WebinarAdapter {
    id: number;
    title: string;
    description: string;
    date: string;
    duration: number;
    link: string;
    tag: string;
    fileId?: number;
}

@Injectable({
    providedIn: 'root',
})
export class LearningHubService {
    protected endpoint = LEARNING_HUB_PATH;
    protected readonly api = inject(RestService);
    readonly productFruitsIsReady = signal(false); // Used to get a trigger when PF is ready
    readonly isDialogVisible = signal(false);

    openDialog(): void {
        this.isDialogVisible.set(true);
    }

    closeDialog(): void {
        this.isDialogVisible.set(false);
    }

    getToursList(): Observable<ListResponse<LearningTourAdapter>> {
        return this.api.get(`${this.endpoint}tours`);
    }

    getCompletedTours(): Observable<{ result: { tourIds: number[] } }> {
        return this.api.get(`${this.endpoint}tours/completed`);
    }

    getWebinarsList(): Observable<ListResponse<WebinarAdapter>> {
        return this.api.get(`${this.endpoint}webinars`);
    }

    trackTourStarted(
        tourId: number,
        tourName: string,
    ): Observable<{ result: { success: boolean } }> {
        return this.api.post(`${this.endpoint}tours/started`, {
            tour_id: tourId,
            tour_name: tourName,
        });
    }

    trackTourFinished(
        tourId: number,
        tourName: string,
    ): Observable<{ result: { success: boolean } }> {
        return this.api.post(`${this.endpoint}tours/finished`, {
            tour_id: tourId,
            tour_name: tourName,
        });
    }
}
